import {
  ListInternationalProductLiabilityClaimsCommand,
  ListInternationalProductLiabilityClaimsInput,
  ListInternationalProductLiabilityClaimsOutput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function listIPLClaimsService(
  input: ListInternationalProductLiabilityClaimsInput,
) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return null;
  }
  const command = new ListInternationalProductLiabilityClaimsCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listIPLClaims");

  return await client
    .send(command)
    .then((response: ListInternationalProductLiabilityClaimsOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
